<ng-container *ngFor="let result of segmentMiles; let last = last">
    <bds-segment-miles-form-item [segmentMiles]="result"></bds-segment-miles-form-item>
    <ng-container *ngIf="!last">
        <hr />
        <br />
    </ng-container>
</ng-container>
